import { createAction, props } from '@ngrx/store';
import { Document } from 'src/app/modules/core/store/models/document.model';
import { SiteWatchFolder, SiteWatchLayer } from './site-watch.model';
import { Dataset } from '../../core/store/models/dataset.model';

//
// Site Watch actions
//
export const showSiteWatch = createAction(
  '[SiteWatch] Show SiteWatch',
  props<{ layerUId: string; document: Document; mapFolders: any[] }>()
);
export const showSiteWatchComplete = createAction(
  '[SiteWatch] Show SiteWatch Complete',
  props<{ layerUId: string; document: Document; venue: string; venueName: string; folders: any[] }>()
);
export const hideSiteWatch = createAction('[SiteWatch] Hide SiteWatch');
export const getSiteWatchConfigurationFromApi = createAction('[SiteWatch] Get Configuration From API');
export const getSiteWatchConfigurationFromApiComplete = createAction(
  '[SiteWatch] Get Configuration From API Complete',
  props<{ configuration: any }>()
);
export const highlightPolyOnMap = createAction('[SiteWatch] Highlight Polygon On Map', props<{ polygonId: string }>());
export const deselectHighlightedObjectsOnMap = createAction('[SiteWatch] Deselect Highlighted Objects On Map');
export const showBlueDot = createAction('[SiteWatch] Show Blue Dot');
export const hideBlueDot = createAction('[SiteWatch] Hide Blue Dot');
export const showDirectionsView = createAction('[SiteWatch] Show Directions View');
export const hideDirectionsView = createAction('[SiteWatch] Hide Directions View');

//
// layer loading
//
export const startLoadAllLayers = createAction(
  '[SiteWatch] Start Load All Layers',
  props<{ mapBoundingBox: string; elevation: number; datasets: Dataset[], officerDatasetUId?: string }>()
);
export const startLoadAllLayersComplete = createAction(
  '[SiteWatch] Start Load All Layers Complete',
  props<{ folders: SiteWatchFolder[]; mapBoundingBox: string }>()
);
export const loadLayerDocuments = createAction(
  '[SiteWatch] Load Layer Documents',
  props<{ layer: SiteWatchLayer; mapBoundingBox: string; elevation: number }>()
);
export const loadLayerDocumentsComplete = createAction(
  '[SiteWatch] Load Layer Documents Complete',
  props<{ layer: SiteWatchLayer; documents: Document[]; geoSourceFieldName: string }>()
);
export const updateFolderAndLayerState = createAction('[SiteWatch] Update Folder and Layer State', props<{ folders: SiteWatchFolder[] }>());
export const loadMappedInLayers = createAction(
  '[SiteWatch] Load MappedIn Layers',
  props<{ amenities: any[]; categories: any[]; locations: any[] }>()
);
export const loadAllLocations = createAction('[SiteWatch] Load All Locations', props<{ locations: any[] }>());
export const setDirections = createAction('[SiteWatch] Set List of Directions', props<{ directions: any[] }>());
export const setStartPoint = createAction('[SiteWatch] Set Start Point', props<{ startPoint: string }>());
export const setEndPoint = createAction('[SiteWatch] Set End Point', props<{ endPoint: string }>());
export const setStartAndEndPoint = createAction('[SiteWatch] Set Start and End Point', props<{ startPoint: string; endPoint: string }>());

//
// document actions
//
export const setSelectedDocumentByUId = createAction('[SiteWatch] Set Selected Document By UId', props<{ uId: string }>());
export const setSelectedDocumentByExternalId = createAction(
  '[SiteWatch] Set Selected Document By ExternalId',
  props<{ externalId: string, isFromCard?: boolean }>()
);
export const setSelectedOfficerDocumentByUId = createAction('[SiteWatch] Set Selected Officer Document By UId', props<{ uId: string }>());

export const newSelectedDocumentComplete = createAction(
  '[SiteWatch] New Selected Document Compete',
  props<{ datasetUId: string; document: Document, isFromCard: boolean }>()
);

//
// folder / layer visibility actions
//
export const showFolder = createAction('[SiteWatch] Show Folder', props<{ folderUId: string }>());
export const hideFolder = createAction('[SiteWatch] Hide Folder', props<{ folderUId: string }>());
export const showLayer = createAction('[SiteWatch] Show Layer', props<{ layerUId: string }>());
export const hideLayer = createAction('[SiteWatch] Hide Layer', props<{ layerUId: string }>());
export const showMappedInAmenity = createAction('[SiteWatch] Show MappedIn Amenity', props<{ id: string }>());
export const hideMappedInAmenity = createAction('[SiteWatch] Hide MappedIn Amenity', props<{ id: string }>());

//
// error handling
//
export const setError = createAction('[SiteWatch] Set Error', props<{ err: any }>());

//
// Card actions
//
export const showCards = createAction('[SiteWatch] Show Cards For Layer', props<{ layer: SiteWatchLayer }>());
export const hideCards = createAction('[SiteWatch] Hide Cards');
